// Résztvevő-ütközések listája a megerősítő dialógusban: KI · melyik megbeszélésen · mikor. A név nyelvhelyes
// alakban (`formatName`), az időpont a megjelenítési zónában.
import { useTranslation } from 'react-i18next';

import { type MeetingParticipantConflict } from '@/features/meetings/participant-conflicts';
import { formatDateTime, useTimeZone } from '@/lib/format-datetime';
import { formatName } from '@/lib/format-name';

export interface MeetingParticipantConflictListProps {
  conflicts: readonly MeetingParticipantConflict[];
}

export function MeetingParticipantConflictList({
  conflicts,
}: MeetingParticipantConflictListProps): JSX.Element {
  const { t, i18n } = useTranslation();
  const timeZone = useTimeZone();
  const range = (c: MeetingParticipantConflict): string => {
    const start = formatDateTime(c.startsAt, i18n.language, timeZone, {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
    const end = formatDateTime(c.endsAt, i18n.language, timeZone, { timeStyle: 'short' });
    return end ? `${start} – ${end}` : start;
  };
  return (
    <ul className="mt-3 space-y-2" aria-label={t('meetings.participantConflict.listLabel')}>
      {conflicts.map((c) => (
        <li
          key={`${c.identityId}:${c.meetingId}`}
          className="border-border rounded-md border px-3 py-2 text-sm"
        >
          <p className="text-foreground font-medium">
            {formatName(
              { givenName: c.givenName, familyName: c.familyName, displayName: c.name },
              i18n.language,
            )}
          </p>
          <p className="text-muted-foreground">
            {c.meetingTitle || t('meetings.participantConflict.untitled')} · {range(c)}
          </p>
        </li>
      ))}
    </ul>
  );
}
